import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import SimpleInput from "../../components/simpleInput/SimpleInput";
import SmallSelectPlaceholder from "../../components/SmallSelectPlaceholder/SmallSelectPlaceholder";
import BirthDate from "../../components/birthDate/BirthDate";
import Button from "../../components/button/Button";
import { AddressPage } from "../../router/path-route/PathRoute";
import moment from "jalali-moment";
import { RegisterStep1 } from "../../auth/Index";
import FormLayout from "../../components/layout/FormLayout";
import SectionCard from "../../components/layout/SectionCard";
import { PersonIcon } from "../../components/layout/MaterialIcons";

const isAlreadyRegistered = (err) => {
  const status = err?.response?.status;
  const message = err?.response?.data?.message || err?.data?.message || "";
  return (
    status === 302 ||
    status === 409 ||
    String(message).includes("قبلا کاربری با این کد ملی")
  );
};

export default function PersonalInformation() {
  const navigate = useNavigate();
  const gender = [
    { value: "زن", key: 0 },
    { value: "مرد", key: 1 },
  ];
  const nationalityItems = [{ value: "ایرانی", key: "IR" }];

  const [checkGender, setCheckGender] = useState(false);
  const [chosen, setChosen] = useState(null);
  const [checkNationality, setCheckNationality] = useState(false);
  const [nationality, setNationality] = useState("");
  const [name, setName] = useState("");
  const [family, setFamily] = useState("");
  const [phone, setPhone] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [checkAge, setCheckAge] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const identityCode =
    localStorage.getItem("identityCode") ||
    localStorage.getItem("IdentityCode") ||
    "";
  const currentShamsiYear = moment().locale("fa").format("jYYYY");

  useEffect(() => {
    if (dateOfBirth !== null && currentShamsiYear - dateOfBirth?.year >= 18) {
      setCheckAge(false);
    } else if (dateOfBirth !== null) {
      setCheckAge(true);
    } else {
      setCheckAge(false);
    }
  }, [dateOfBirth, currentShamsiYear]);

  const isValid =
    name !== "" &&
    family !== "" &&
    checkGender === true &&
    checkNationality === true &&
    dateOfBirth !== null &&
    checkAge === false;

  const goToAddress = (token) => {
    if (token) {
      localStorage.setItem("token", token);
    }
    navigate(AddressPage);
  };

  const handleSubmit = () => {
    if (!isValid || loading) return;
    setLoading(true);
    setErrorMessage("");
    const data = {
      name,
      family,
      IdentityCode: localStorage.getItem("IdentityCode"),
      mobile: localStorage.getItem("mobile"),
      gender: chosen,
      nationality: nationality || "IR",
      phone: phone === "" ? null : phone,
      birthDate: moment(dateOfBirth?.toDate()).local("fa").format("YYYY-MM-DD"),
      photo: null,
    };
    RegisterStep1(data)
      .then((res) => {
        const message = res.data?.message || "";
        if (String(message).includes("قبلا کاربری با این کد ملی")) {
          goToAddress(res.data?.token);
          return;
        }
        if (res.status === 200 || res.status === 302) {
          goToAddress(res.data?.token);
        }
      })
      .catch((err) => {
        if (isAlreadyRegistered(err)) {
          goToAddress(err.response?.data?.token);
          return;
        }
        setErrorMessage(err.response?.data?.message || "ثبت اطلاعات ناموفق بود.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <FormLayout
      footer={
        <div className="w-full">
          {errorMessage ? (
            <div className="text-scabRed text-small text-center mb-2">
              {errorMessage}
            </div>
          ) : null}
          <Button
            title={loading ? "در حال ثبت..." : "ثبت و ادامه"}
            bgButton={isValid && !loading}
            handleClick={handleSubmit}
          />
        </div>
      }
    >
      <SectionCard
        icon={<PersonIcon />}
        iconBg="bg-[#3B82F6]"
        title="اطلاعات شخصی"
        subtitle="مشخصات اولیه حساب کاربری خود را وارد کنید"
      >
        <SimpleInput
          title="نام"
          required
          setInputValue={setName}
          inputValue={name}
          placeholder="نام خود را اینجا وارد کنید"
          valueType="text"
        />
        <SimpleInput
          title="نام خانوادگی"
          required
          setInputValue={setFamily}
          inputValue={family}
          placeholder="نام خانوادگی خود را اینجا وارد کنید"
          valueType="text"
        />
        <div className="w-full flex gap-3 mb-1">
          <div className="w-1/2">
            <div className="mb-2 flex justify-start items-center text-medium font-IRANSansBold">
              جنسیت<span className="text-scabRed mr-1">*</span>
            </div>
            <SmallSelectPlaceholder
              items={gender}
              setSelectItem={setCheckGender}
              chosen={chosen}
              setChosen={setChosen}
              fullWidth
            />
          </div>
          <div className="w-1/2">
            <div className="mb-2 flex justify-start items-center text-medium font-IRANSansBold">
              ملیت<span className="text-scabRed mr-1">*</span>
            </div>
            <SmallSelectPlaceholder
              items={nationalityItems}
              setSelectItem={setCheckNationality}
              chosen={nationality}
              setChosen={setNationality}
              fullWidth
            />
          </div>
        </div>
        <div className="w-full flex gap-3 mt-4 mb-1">
          <div className="w-1/2">
            <SimpleInput
              title="کد ملی (غیرقابل تغییر)"
              inputValue={identityCode}
              valueType="text"
              readOnly
            />
          </div>
          <div className="w-1/2">
            <SimpleInput
              title="تلفن ثابت (اختیاری)"
              setInputValue={setPhone}
              inputValue={phone.slice(0, 11)}
              placeholder="به همراه کد شهر"
              valueType="number"
            />
          </div>
        </div>
        <BirthDate
          title="تاریخ تولد"
          required
          setDateOfBirth={setDateOfBirth}
          dateOfBirth={dateOfBirth}
          checkAge={checkAge}
        />
        <div className={`text-scabRed text-small ${checkAge ? "flex" : "hidden"}`}>
          فقط افراد بالای 18 سال میتوانند ثبت نام کنند.
        </div>
      </SectionCard>
    </FormLayout>
  );
}
